import { lazy } from "react";

const Profile1 = lazy(() => import("../Component/Profile/Profile1"));

const profileRoutes = [{ path: "/profile", element: <Profile1 />, protected: true }];

export default profileRoutes;
